// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__4Vg5N","text-orange":"Card_text-orange__Qr-YM","label":"Card_label__ObSQZ"};